class DotEmailVariantsHelper {
  static getHeaderColumn($container) {
    Responsive.getCalendarColumn($container.parent(), $container, 250, 200, 7);
  }

  static types() {

    return [
      {id: 'emailsSent', name: 'Emails Sent', info: ''},
      {
        id: 'delivered',
        name: 'Delivered',
        info: 'An email delivered status means that the email was successfully sent and accepted by the recipient\'s email server. However, it doesn\'t necessarily mean that the email was delivered to the recipient\'s inbox. The recipient\'s email provider may have filtered the email into spam or discarded it altogether.'
      },
      {
        id: 'open',
        name: 'Unique Opens',
        info: 'Email unique opens is a metric that measures the number of unique recipients who opened an email at least once. It\'s calculated by dividing the total number of unique recipient email opens by the number of emails delivered in the campaign.'
      },
      {
        id: 'click',
        name: 'Unique Clicks',
        info: 'In email marketing, unique clicks is a metric that counts the number of unique recipients who clicked on at least one link in an email.'
      },
      {
        id: 'bounce',
        name: 'Bounces',
        info: 'An email bounce rate is the percentage of emails that are not delivered to a recipient\'s inbox and are returned to the sender. This stat can include various rejection types from blocks, bounces, reputation, or bad email addresses.'
      },
      {
        id: 'unsubscribe',
        name: 'Unsubscribes',
        info: 'An email unsubscribe rate is the percentage of email subscribers who opt out of receiving emails from a company or brand. It\'s calculated by dividing the number of unsubscribed users by the number of emails sent, and then multiplying by 100.'
      },
      {
        id: 'spamReport',
        name: 'Marked Spam',
        info: 'The percentage of emails delivered that are marked as spam. A low spam rate is important because spam complaints can harm your sender reputation and spam score. This rate does not include spam reports from Gmail as they do not provide them.'
      },

    ];
  }

}

class DotEmailVariantsList extends TableList {
  /**
   * Constructs an instance of the CampaignList class.
   */
  constructor(app, parentContainer, container, aimiEmailCampaignId, listRow, sortBy, sortByDirection) {
    super(app, container, listRow, false);
    if (!app.isEmpty(sortBy)) {
      this.sortBy = sortBy;
    } else {
      this.sortBy = 'id';
    }

    if (!app.isEmpty(sortByDirection)) {
      this.sortByDirection = sortByDirection;
    } else {
      this.sortByDirection = 'ASC';
    }

    this.searchParams = !app.isEmpty(window['searchParams']) ? window['searchParams'] : null;

    this.aimiEmailCampaignId = aimiEmailCampaignId;
    this.parentContainer = parentContainer;
    this.container.empty();
    this.paginator = new Paginator(100);
    this.renderList = this.renderList.bind(this);
    this.paginatedUrl = new PaginatedUrl(`/api/mdcdot/email-variants/${aimiEmailCampaignId}`, 1, 100);

    this.renderList(1);
  }

  prepareRow(row) {
    const statsDefault = {

      version : 'Current',
      emailSubject: this.staticPH,
      leadsAdded: this.staticPH,
      emailsSent: this.staticPH,
      delivered: this.staticPH,
      open: this.staticPH,
      click: this.staticPH,
      bounce: this.staticPH,
      unsubscribe: this.staticPH,
      spamReport: this.staticPH,
      deliveredRate: this.staticPH,
      openRate: this.staticPH,
      clickRate: this.staticPH,
      bounceRate: this.staticPH,
      unsubscribeRate: this.staticPH,
      spamReportRate: this.staticPH
    };

    const page = _.template(this.app.templates[this.listRow]);

    let pageData = {
      ...statsDefault,
      ...row,
      ...MdcDotCampaign.calculateEmailMetrics(row),
    };

    const $page = $(page(pageData));

    return $page;
  }

  loaderData = {
    id: null,
    aimiEmailCampaignId : '',

    version : this.staticPH,
    emailHtml : this.staticPH,
    emailSubject: this.staticPH,
    name: this.staticPH,
    leadsAdded: this.staticPH,
    emailsSent: this.staticPH,
    delivered: this.staticPH,
    open: this.staticPH,
    click: this.staticPH,
    bounce: this.staticPH,
    unsubscribe: this.staticPH,
    spamReport: this.staticPH,
    deliveredRate: this.staticPH,
    openRate: this.staticPH,
    clickRate: this.staticPH,
    bounceRate: this.staticPH,
    unsubscribeRate: this.staticPH,
    spamReportRate: this.staticPH
  }

  processedLoaderData(overrideData = {}) {
    let data = this.loaderData;

    data = {...data, ...overrideData};
    return data;
  }

  updateVariantsData(emailVariantCampaign, data = {}) {
    const self = this;
    _.each(data, function (emailData, key) {
      if (window.emailVariantsIndexById[key]) {
        const row = emailData;
        const emailRow = $(`.email-variant-row[data-row=${row.id}]`);
        const $row = self.prepareRow(row);
        emailRow.replaceWith($row);
      }

    })
  }

  async fetchEmailVariantsStat(emailVariantCampaign) {

    // Simulating an API call
    //await this.updateVariantsData(emailVariant, false);
    const searchParams = !this.app.isEmpty(window['searchParams']) ? window['searchParams'] : null;

    let response;

    response = await this.app.apis['mdcdot']['emailVariant'].refresh(emailVariantCampaign.aimiEmailCampaignId, searchParams);
    if (response.totals) {
      MdcDotCampaign.updateStatsHeader(response.totals);
    }
    await this.updateVariantsData(emailVariantCampaign, response[emailVariantCampaign.aimiEmailCampaignId].emailVariantsData);
    return await response; // Assuming the response is in JSON format
  }


  async renderList(page) {
    const self = this;
    const $listContainer = this.container
    const $parentContainer = this.parentContainer;
    let emails = [];
    this.isRendering = true;

    if (this.app.isEmpty(window.emailVariantsIndexById)) {
      window.emailVariantsIndexById = {};
    }

    try {
      if (page) {

        if (this.lazyloader) {
          this.lazyloader.destroy();
        }

        this.showLoader(this.processedLoaderData());
        MdcDotCampaign.statsHeaderLoader();

        $parentContainer.find('.btn-sort').attr('disabled', 'disabled');

        const $pageTitle = $('[data-count-all-email-variants]');
        $pageTitle.addClass('animated flash');
        const response = await this.app.apis['mdcdot'].campaign.list(this.paginatedUrl.getPageUrl(page), this.sortBy, this.sortByDirection, this.searchParams);
        this.apiResponse = response;


        $pageTitle.removeClass('animated flash');
        $pageTitle.text(`(${response.total})`);
        $pageTitle.data('count-all-email-variants', response.total)
        $('.rows-selector-wrapper').find('button[data-campaign-action]').removeAttr('disabled');
        $parentContainer.find('.btn-sort').removeAttr('disabled');

        this.paginatedUrl.setPageCount(response.pages);
        this.paginator.setData(response.result);
        this.paginator.setCurrentPage(1);

        emails = this.paginator.getCurrentPage();
      } else {
        emails = this.paginator.getNextPage();
      }

      this.removeLoader();

      if (!this.app.isEmpty(emails)) {
        _.each(emails, function (row) {
          emailVariantsIndexById[row.id] = row;
          let $row = self.prepareRow(row);
          $row.appendTo($listContainer);
        });

        this.app.initTooltip();

        await this.fetchEmailVariantsStat(this.apiResponse, this.apiResponse.searchFilter);

        this.isRendering = false;

        let hasMoreData = this.paginator.hasMoreData();
        return hasMoreData;

      } else if (this.app.isEmpty(window.emailVariantsIndexById)) {
        let message = 'No Records found';
        let description = 'You have no email variants';
        if (this.apiResponse.error) {
          message = 'No instance connected';
          description = 'Please select an instance or contact help for support'
        }

        const noRecordsOptions = {
          title: message,
          class: 'available-mdcdot-table-height no-campaigns',
          description: description,
          help: {
            text: 'Need Help ?',
            onClick: () => {
              console.log('Help clicked');
              // Code to open help documentation or contact support
            }
          }
        };
        const placeholder = new NoRecordsPlaceholder(this.app, this.container.closest('.table-responsive'), noRecordsOptions);
        placeholder.render();
      }

    } catch (error) {
      console.error("Error occurred during operation:", error);
    }

  }
}


(function (aimi_mdcdot_email_variant, $, app, undefined) {
  // Private object
  let __this = {};

  aimi_mdcdot_email_variant.list = {
    listRow: 'dot_email__row',

    buttons: function () {
      return {
        disable: function () {
          $(__this.containerRoot).find('button').attr('disabled', 'disabled');
        },
        enable: function () {
          $(__this.containerRoot).find('button').removeAttr('disabled');
        },
        disableRefresh: function () {
          $(__this.containerRoot).find('button[data-campaign-action="refresh-data"]').hide();
          const key = $('[data-item="campaignDataLastUpdatedOn"]');
          key.hide();
        },
        enableRefresh: function () {
          $(__this.containerRoot).find('button[data-campaign-action="refresh-data"]').show();
          const key = $('[data-item="campaignDataLastUpdatedOn"]');
          key.show();
        }
      }
    },
    init: function (containerRoot, aimiEmailCampaignId) {
      const self = this;
      __this.containerRoot = containerRoot;
      const $parentContainer = $(__this.containerRoot);
      const $listContainer = $('[data-email-variants]', $parentContainer);

      const emailVariantsCampaign = new EventManager('email-variants-view-actions', `${__this.containerRoot} [data-email-variants-action]`);

      self.buttons().disable();

      // Add header columns
      const $headerContainer = $('[data-email-variants-header]', $parentContainer);

      _.each(DotEmailVariantsHelper.types(), function (type) {
        const metrics = _.template(app.templates['dot_campaign__header-col']);
        const $metrics = $(metrics(type));
        $metrics.appendTo($headerContainer);
      });

      app.initTooltip();

      __this.listMananger = new DotEmailVariantsList(app,$parentContainer, $listContainer, aimiEmailCampaignId, self.listRow);
      __this.listMananger.onRenderList().then(function () {
        self.buttons().enable();
      });


      emailVariantsCampaign.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        const $this = $(this);
        const action = $this.data('email-variants-action');

        if(action === 'view') {
          previewEmailVariant($this.data('id'));
        }
      })

      DotEmailVariantsHelper.getHeaderColumn($headerContainer, $headerContainer);

    },
  }
}(window.aimi_mdcdot_email_variant = window.aimi_mdcdot_email_variant || {}, jQuery, PreBuilt));

